export function addRatioSwitcher(ratioCheckbox, standardsTable)
{
    ratioCheckbox.addEventListener('change', function () {
        standardsTable.classList.toggle('standards__table--ratios', this.checked);
        gtag('event', 'ratio-change', { 'event_category': 'standards' });
    });
}